import React from "react";
import {
    Routes,
    Route
} from "react-router-dom";


import {
    publicRoutes,
    authProtectedRoutes
} from "./allRoutes";


import {
    AuthProtected
} from "./AuthProtected";



const Index = () => {


    return (

        <React.Fragment>

            <Routes>


                {/* =====================
                    PUBLIC ROUTES
                ====================== */}

                {
                    publicRoutes.map(
                        (route, idx) => (

                            <Route

                                key={idx}

                                path={route.path}

                                element={
                                    route.component
                                }

                            />

                        )
                    )
                }



                {/* =====================
                    PROTECTED ROUTES
                ====================== */}

                {
                    authProtectedRoutes.map(
                        (route, idx) => (
                            <Route
                                key={idx}
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        {route.component}
                                    </AuthProtected>
                                }
                            />
                        )
                    )
                }
            </Routes>
        </React.Fragment>
    );
};

export default Index;